import ChargeHelper, { ChargeConstants } from 'features/Charge/chargeHelper';
import KTLabel, { KTLabelSize } from 'general/components/OtherKeenComponents/KTLabel';
import AppColors from 'general/constants/AppColors';
import AppResource from 'general/constants/AppResource';
import UIHelper from 'general/helpers/UIHelper';
import Utils from 'general/utils/Utils';
import _ from 'lodash';
import PropTypes from 'prop-types';

StationInfoBoxView.propTypes = {
  station: PropTypes.object,
  onClicked: PropTypes.func,
};

function StationInfoBoxView({ station, onClicked }) {
  return (
    <div
      style={{
        maxWidth: '300px',
      }}
      className={`${onClicked ? 'cursor-pointer hover-opacity-80' : ''}`}
      onClick={onClicked}
    >
      <div
        className="bg-white overflow-hidden shadow"
        style={{
          borderRadius: '10px',
        }}
      >
        {/* anh tram sac */}
        <div
          className=""
          style={{
            width: '300px',
            aspectRatio: '320/170',
          }}
        >
          <img
            className="w-100 h-100"
            style={{
              objectFit: 'cover',
            }}
            src={
              Utils.isValid(station?.image)
                ? Utils.getFullUrl(station?.image)
                : AppResource.images.chargeConnectorTypes.imgChargeStationDefault
            }
            alt={station?.name}
          />
        </div>
        {/* ten tram sac */}
        <div className={`d-flex flex-column gap-2 p-4`}>
          <span style={UIHelper.buildFontStyle('600', '16px', 'rgba(73, 73, 104, 1)')}>
            {station?.name}
          </span>
          <div className="d-flex align-items-center gap-2">
            <KTLabel
              text={ChargeHelper.Utils.getChargeStationStatusName(station?.status)}
              isInline={true}
              size={KTLabelSize.medium}
              additionalClassName={`label-light-${ChargeHelper.Utils.getChargeStationStatusColor(
                station?.status
              )}`}
            />
            <div
              className="d-flex flex-row overflow-hidden"
              style={{
                borderRadius: '8px',
                border: '1px solid rgba(219, 223, 241, 1)',
              }}
            >
              <div
                style={UIHelper.buildFontStyle('500', '16px', 'rgba(114, 114, 139, 1)')}
                className="px-2 py-1 align-items-center justify-content-center"
              >
                AC
              </div>
              <div
                style={{
                  ...UIHelper.buildFontStyle('600', '14px', '#fff'),
                  backgroundColor: 'rgba(48, 189, 111, 1)',
                }}
                className="px-2 py-1 d-flex align-items-center justify-content-center"
              >
                {`${_.filter(
                  station?.chargePoints,
                  (item) => item?.chargeModel?.type === ChargeConstants.ChargePointType.AC
                )?.length
                  }/${station?.chargePoints?.length}`}
              </div>
            </div>
            <div
              className="d-flex flex-row overflow-hidden"
              style={{
                borderRadius: '8px',
                border: '1px solid rgba(219, 223, 241, 1)',
              }}
            >
              <div
                style={UIHelper.buildFontStyle('500', '16px', 'rgba(114, 114, 139, 1)')}
                className="px-2 py-1 align-items-center justify-content-center"
              >
                DC
              </div>
              <div
                style={{
                  ...UIHelper.buildFontStyle('600', '14px', '#fff'),
                  backgroundColor: 'rgba(48, 189, 111, 1)',
                }}
                className="px-2 py-1 d-flex align-items-center justify-content-center"
              >
                {`${_.filter(
                  station?.chargePoints,
                  (item) => item?.chargeModel?.type === ChargeConstants.ChargePointType.DC
                )?.length
                  }/${station?.chargePoints?.length}`}
              </div>
            </div>
          </div>
          <div className="d-flex flex-column gap-1">
            <div className="d-flex align-items-start gap-2">
              <i className="fa-solid fa-location-dot py-1" style={{ color: AppColors.primary }} />
              <span style={UIHelper.buildFontStyle('400', '14px', 'rgba(114, 114, 139, 1)')}>
                {ChargeHelper.Utils.getChargeStationFullAddress(station)}
              </span>
            </div>
            <div className="d-flex align-items-start gap-2">
              <i className="fa-solid fa-bolt py-1" style={{ color: AppColors.primary }} />
              <span style={UIHelper.buildFontStyle('400', '14px', 'rgba(114, 114, 139, 1)')}>
                {`${ChargeHelper.Utils.getChargeStationAvailablePoints(station?.chargePoints)}/${station?.chargePoints?.length
                  } Trụ sạc còn trống`}
              </span>
            </div>
          </div>
        </div>
      </div>
      {/* caret */}
      <div className="w-100 bg-transparent h-10px">
        <div
          style={{
            width: 0,
            height: 0,
            borderLeft: '10px solid transparent',
            borderRight: '10px solid transparent',
            borderTop: '10px solid white',
            margin: '0 auto',
          }}
        ></div>
      </div>
    </div>
  );
}

export default StationInfoBoxView;
